import { PhoneNumberFormat } from 'google-libphonenumber';
import { PhoneNumberUtil } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();

/**
 * @param {string} phoneNumber - the number to evaluate
 * @returns {string|null} the country code for the given phone number. Defaults to 'US' if the number does not
 * contain a country code (ex. (321) 456-7890)
 */
export function getCountryCode(phoneNumber) {
  try {
    return phoneUtil.getRegionCodeForNumber(phoneUtil.parse(phoneNumber, ""));
  } catch (numberParseException) {
    return 'US'; //  if there is no country code, assume US
  }
}

/**
 * This function takes a string and if it is a valid number, will attempt to format it using google-libphonenumber.
 * @param {string} phoneNumber - the input number to be formatted
 * @returns {string|*} a formatted number or the provided object if formatting not possible
 */
export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber || typeof phoneNumber !== 'string') return phoneNumber;
  try {
    const countryCode = getCountryCode(phoneNumber);
    return phoneUtil.format(phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode),
        countryCode === 'US' ? PhoneNumberFormat.NATIONAL : PhoneNumberFormat.INTERNATIONAL);
  } catch (err) {
    return phoneNumber;
  }
}
